module.exports = __webpack_public_path__ + "static/img/image_recruit_05.13d0f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_05.png
// module id = Nmwd
// module chunks = 10